import {
    applyMiddleware,
    combineReducers,
    compose,
    createStore as createReduxStore,
} from 'redux'
import reduxThunk from 'redux-thunk'

import operatorDashboardReducers from './App/Dashboard/reducers'
import operatorDashboardPeriodsReducers from './App/Dashboard/Header/PeriodPicker/reducers'
import operatorDashboardUserSearchReducers from './App/Dashboard/Header/UserSearch/reducers'
import operatorDashboardAccountSelectorReducers from './App/Dashboard/Header/AccountSelector/reducers'
import operatorDashboardDetailsReducers from './App/Dashboard/Details/reducers'
import operatorDashboardMessageReducers from './App/Dashboard/Dialogue/OperatorEditBox/reducers'
import operatorDashboardUtilsReducers from './App/Dashboard/Utils/reducers'

import conversationPanelReducers from './App/Conversation/reducers'

const reducers = combineReducers({
    operatorDashboard: operatorDashboardReducers,
    operatorDashboardPeriods: operatorDashboardPeriodsReducers,
    operatorDashboardUserSearch: operatorDashboardUserSearchReducers,
    operatorDashboardAccountSelector: operatorDashboardAccountSelectorReducers,
    operatorDashboardDetails: operatorDashboardDetailsReducers,
    operatorDashboardMessage: operatorDashboardMessageReducers,
    operatorDashboardUtils: operatorDashboardUtilsReducers,

    conversationPanel: conversationPanelReducers,
})

export default () => createReduxStore(
    reducers,
    compose(
        applyMiddleware(reduxThunk),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
    // const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createReduxStore)
    // const store = createStoreWithMiddleware((state, action) => (reducers(state, action)))
)
